import { motion } from "framer-motion";
import { waLink } from "@/lib/contact";

const links = [
  { label: "About", href: "#about" },
  { label: "Physiotherapy", href: "#physiotherapy" },
  { label: "Strength", href: "#strength" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-[#F5F0E8]/80 backdrop-blur-xl border-b border-[#E5E0D8]"
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/logo-icon.png" alt="Physiora logo" className="h-9 w-9 object-contain" />
          <span className="font-display text-2xl tracking-tight text-[#111111]">
            Physiora
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs tracking-[0.2em] uppercase font-medium text-[#111111]/70 hover:text-[#111111] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={waLink("Hi Physiora, I'd like to book a physiotherapy consultation.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-book-btn"
          className="group inline-flex items-center gap-2 bg-[#111111] text-[#F5F0E8] text-xs tracking-[0.15em] uppercase font-medium px-5 md:px-7 py-2.5 md:py-3 rounded-full hover:bg-[#8DA37F] hover:text-[#111111] transition-colors duration-300"
        >
          Book a consult
        </a>
      </div>
    </motion.header>
  );
}
